import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CustomBtn from "./ButtonTemplate";

interface CancelBtnProps {
  action: () => void;
  tip: string;
}

function CancelBtn({ action, tip }: CancelBtnProps) {
  return (
    <CustomBtn action={action} type="danger" icon={<CloseIcon />} tip={tip} />
  );
}

export default CancelBtn;
